import { render, staticRenderFns } from "./ProfileModal.vue?vue&type=template&id=23967c24&"
import script from "./ProfileModal.vue?vue&type=script&lang=js&"
export * from "./ProfileModal.vue?vue&type=script&lang=js&"
import style0 from "./ProfileModal.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports